import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";

export default function ControlSelectCell({ getValue, table, column, applyToAll }) {
  const data = getValue();
  const weekday = column.columnDef.header;
  const shift = column.columnDef?.id.toLowerCase().includes("ochtend") ? "Ochtend" : "Middag";

  const handleChange = (e) => {
    const checked = e.target.checked;
    table.options.meta?.handleDatesSelection(shift, weekday, checked, applyToAll);
  };

  if (!data || !data.hasDays) return <div className="text-center"></div>;

  return (
    <div className="text-center">
      <Input
        type="checkbox"
        checked={!!data.isSelected}
        onChange={handleChange}
        className="planscreen__checkbox m-0"
      />
    </div>
  );
}
